export const BEERSWEEPER = '/beersweeper';
export const MATRIX = '/matrix';
export const HOME = '/';
export const DATA = '/data';